import { render, staticRenderFns } from "./FormComment.vue?vue&type=template&id=3f5a984b&scoped=true&"
import script from "./FormComment.vue?vue&type=script&lang=js&"
export * from "./FormComment.vue?vue&type=script&lang=js&"
import style0 from "./FormComment.vue?vue&type=style&index=0&id=3f5a984b&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f5a984b",
  null
  
)

export default component.exports